export default "__VITE_ASSET__DXPRfkO8__"